import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/prag/page.tsx");
